/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import AmountOfUse from '../../../../claim/shared/components/claim-fields/amount-of-use/amount-of-use-without-compliance';
import AmountOfUseHistoryPanelItem from './amount-of-use-history-panel-item';
import AmountOfUseHistoryPanelListHeader from './amount-of-use-history-panel-list-header';
import FileAttachmentPanel from '../../../../shared/components/file-attachment-panel';
import {FormattedMessage} from 'react-intl';
import LabeledDateInput from '../../../../claim/shared/components/claim-fields/labeled-date-input';
import LabeledTextArea from '../../../../claim/shared/components/claim-fields/labeled-text-area';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import {findMatchingKey} from '../../../../claim/shared/services/claim-shared-helper';
import {generateTemporaryObjectKey} from '../../../../shared/services/generate-temporary-object-key';

function handleButtonClick() {

    const payload = {...this.updateAmountOfUseMeasurement, latestPerUnit: true, status: 'NEW'};

    this.actions.addAmountOfUseRecord(payload, this.product.pin);

    this.onCloseButtonClick();

}

function handleFileDelete(file) {

    this.actions.deleteFileAddAmountOfUse(file);

}

function handleFileUploadSuccess(file, dropzone) {

    const fileObject = JSON.parse(file.xhr.response);

    this.actions.addFileForUpdateAmountOfUse(fileObject);

    dropzone.removeFile(file);

}

function handleAmountOfUseCommentsChange(event) {

    this.actions.updateUnitMeasurements('dealerComments', event);

}

function handleupdateDateAmountOfUseChange(event) {

    this.actions.updateUnitMeasurements('date', event);

}

function handleUseAmountBlur(amount) {

    if (this.product.otherUnitRequired === 'N') {

        this.actions.updateAmountUnitInMeasurementReading('amount', amount);

    }

}

function handleUseAmountChange(amount) {

    this.actions.updateAmountUnitInMeasurementReading('amount', amount);

}

function handleUnitOptionChange(unitKey) {

    const useAmountUnit = findMatchingKey(unitKey, this.product.useAmountAllowedUnits);

    this.actions.updateAmountUnitInMeasurementReading('unit', useAmountUnit);

}

const AmountOfUseHistoryPanelBody = props =>
    <section className='amount-of-use-history-panel-body'>

        <LabeledDateInput
            className='amount-of-use-date required'
            date={props.updateAmountOfUseMeasurement.date}
            isEditable={true}
            isValid={true}
            label='DATE'
            onDateChange={handleupdateDateAmountOfUseChange.bind(props)}
        />
        {props.amountOfUseHistory[0].useAmount &&
        <AmountOfUse
            allowedUnits={props.product.useAmountAllowedUnits}
            className='amount-of-use required'
            dropdownTabIndex='8'
            inputTabIndex='7'
            isEditable={true}
            isValid={true}
            onInputBlur={handleUseAmountBlur.bind(props)}
            onInputChange={handleUseAmountChange.bind(props)}
            onOptionChange={handleUnitOptionChange.bind(props)}
            selectedUnit={props.updateAmountOfUseMeasurement.useAmount.unit}
            showBlankOption={true}
            value={props.updateAmountOfUseMeasurement.useAmount.amount}
        />}
        <button
            className='primary-button'
            disabled={(props.updateAmountOfUseMeasurement.useAmount.amount === null) || (props.updateAmountOfUseMeasurement.useAmount.unit.key === '') || (props.updateAmountOfUseMeasurement.dealerComments === '') || (props.updateAmountOfUseMeasurement.date === 0)}
            onClick={handleButtonClick.bind(props)}
        >
            <FormattedMessage id='UPDATE'/>
        </button>
        <AmountOfUseHistoryPanelListHeader/>
        <section className='amount-of-use-history-panel-list'>
            {props.amountOfUseHistory.map((measurementReading, index) =>
                <AmountOfUseHistoryPanelItem
                    amountRecorded={measurementReading.useAmount.amount}
                    date={measurementReading.date}
                    description={measurementReading.description}
                    key={index}
                    unit={measurementReading.useAmount.unit.value}
                />
            )}
        </section>
        <div className='amount-of-use-file'>
            <FileAttachmentPanel
                files={props.updateAmountOfUseMeasurement.file}
                onFileDelete={handleFileDelete.bind(props)}
                onFileUploadSuccess={handleFileUploadSuccess.bind(props)}
                serviceConfig={{
                    className: 'BUS2092',
                    classType: 'OT',
                    objectKey: props.updateAmountOfUseMeasurement.file.length ? props.updateAmountOfUseMeasurement.file[0].objectKey : generateTemporaryObjectKey()
                }}
            />
        </div>
        <LabeledTextArea
            className='amount-of-use-comment required'
            disabled={false}
            isEditable={true}
            label='COMMENTS'
            maxLength={120}
            onChange={handleAmountOfUseCommentsChange.bind(props)}
            rows={5}
            value={props.updateAmountOfUseMeasurement.dealerComments}

        />
    </section>;

AmountOfUseHistoryPanelBody.displayName = 'AmountOfUseHistoryPanelBody';
AmountOfUseHistoryPanelBody.propTypes = {
    actions: PropTypes.object,
    amountOfUseHistory: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onCloseButtonClick: PropTypes.func,
    product: PropTypes.instanceOf(Product).isRequired,
    updateAmountOfUseMeasurement: PropTypes.instanceOf(MeasurementReading)
};
export default AmountOfUseHistoryPanelBody;



// WEBPACK FOOTER //
// ./src/shared/components/amount-of-use-with-modal/amount-of-use-edit-modal/amount-of-use-history-panel-body.js